import ReportingRegime from "../../../infrastructure/types/common/ReportingRegime";

const getAccuracyReportRawDataSource = (regime: string) => {

    switch (regime) {
        case ReportingRegime.Mifir: return 'CN_MiFIR';
        case ReportingRegime.EmirOld: return 'CN_EMIR';
        case ReportingRegime.Refit: return 'CN_REFIT';
        case ReportingRegime.MasOld: return 'CN_MAS';
        case ReportingRegime.AsicOld: return 'CN_ASIC';
        case ReportingRegime.MasRewrite: return 'CN_MAS_Rewrite';
        case ReportingRegime.AsicRewrite: return 'CN_ASIC_Rewrite';
        case ReportingRegime.OscRewrite: return 'CN_OSC_Rewrite';
        case ReportingRegime.Iirock: return 'CN_IIROC';
        case ReportingRegime.MifirCb: return 'CN_MiFIR_Cb';
        case ReportingRegime.MifirCommodityPosition: return 'CN_MiFIR_Cp';
        case ReportingRegime.SixDerivatives: return 'CN_SIX_Derivatives';
        case ReportingRegime.SixSecurities: return 'CN_SIX_Securities';
        case ReportingRegime.Sftr: return 'CN_SFTR';
        case ReportingRegime.MifirTransparency: return 'CN_MiFIR_Transparency';
        case ReportingRegime.Cat: return 'CN_CAT';
        case ReportingRegime.Remit: return 'CN_REMIT';

        default: return '';
    };
}

let accuracyDataSourceFormHelper = {
    getAccuracyReportRawDataSource
}

export default accuracyDataSourceFormHelper;